import React from 'react'
import { useParams, Navigate, useLocation } from 'react-router-dom'
import { useJourneyStore } from '@/stores/journeyStore'
import { Stage0Presentation } from '@/components/stages/Stage0Presentation'
import { Stage1Chat } from '@/components/stages/Stage1Chat'
import { Stage2Collaboration } from '@/components/stages/Stage2Collaboration'
import { Stage3Automation } from '@/components/stages/Stage3Automation'
import { Stage4Analytics } from '@/components/stages/Stage4Analytics'
import { Stage5Recommendations } from '@/components/stages/Stage5Recommendations'

export function StagePage() {
  const { stageId } = useParams<{ stageId: string }>()
  const { stages } = useJourneyStore()
  const location = useLocation()
  
  // Handle /overview route - always show Stage 0
  const isOverviewRoute = location.pathname === '/overview'
  const stageNumber = isOverviewRoute ? 0 : parseInt(stageId || '0')
  const stage = stages.find(s => s.id === stageNumber)
  
  // For overview route, don't check if stage is locked - allow public access
  if (!isOverviewRoute && (!stage || (stage.isLocked && !stage.isCompleted))) {
    return <Navigate to="/" replace />
  }

  // Render the appropriate stage component
  switch (stageNumber) {
    case 0:
      return <Stage0Presentation />
    case 1:
      return <Stage1Chat />
    case 2:
      return <Stage2Collaboration />
    case 3:
      return <Stage3Automation />
    case 4:
      return <Stage4Analytics />
    case 5:
      return <Stage5Recommendations />
    default:
      return <Navigate to="/" replace />
  }
}